<template>
  <div class="panel panel-simple">
    <div :class="isLoading ? 'loader-box inProgress' : ''">
      <div class="loader-row" v-show="isLoading">
        <img src="/static/assets/images/loading.gif">
      </div>
      <div :class="isLoading ? 'panel-body disabled' : 'panel-body'">
        <div class="huge">{{value}}{{symbol}}</div>
        <div class="desc">{{title}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'account-summary-box',
    props: {
      title: '',
      value: {
        default: function () {
          return 0
        }
      },
      symbol: '',
      isLoading: true
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AccountSummaryBox.vue